
import { createSvgIcon } from "@mui/material/utils";

export const MessageProfileIcon = createSvgIcon(
    <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="19.5" fill="white" stroke="#F2F2F2" />
    <path
      d="M18.0102 20.0348C18.0102 20.9364 17.3099 21.6681 16.4419 21.6681C15.5738 21.6681 14.8735 20.9364 14.8735 20.0348C14.8735 19.1333 15.5738 18.4059 16.4419 18.4059C17.3099 18.4059 18.0102 19.1376 18.0102 20.0348ZM23.4177 18.4059C22.5517 18.4059 21.8493 19.1376 21.8493 20.0348C21.8493 20.9321 22.5517 21.6681 23.4177 21.6681C24.2836 21.6681 24.986 20.9364 24.986 20.0348C24.986 19.1333 24.2857 18.4059 23.4177 18.4059ZM35 20C35 21.8184 33.8133 23.3188 32.268 23.5801C30.8778 27.3301 27.3742 30 23.2793 30H16.7207C12.6258 30 9.12217 27.3301 7.73204 23.5801C6.18675 23.3188 5 21.8184 5 20C5 18.1816 6.18675 16.6834 7.73204 16.422C9.12217 12.672 12.6258 10 16.7207 10H23.2793C27.3742 10 30.8778 12.672 32.268 16.422C33.8133 16.6834 35 18.1838 35 20ZM27.8837 19.9281C27.8837 18.5867 27.3595 17.3759 26.5145 16.4961C25.6675 15.6185 24.5017 15.074 23.2101 15.074H16.6515C14.0704 15.074 11.9758 17.2474 11.9758 19.9281C11.9758 21.2696 12.5021 22.4826 13.3471 23.3602C14.1921 24.2378 15.3599 24.7844 16.6515 24.7844H20.2789V26.5984C20.2789 27.0361 20.7443 27.2975 21.0966 27.0623L25.1412 24.3467C26.7452 23.2622 27.8837 21.8946 27.8837 19.9281Z"
      fill="#9E9E9E"
    />
  </svg>,
  "MessageProfileIcon"
);
